import { SiteLoaderLogo } from '@/components/layout/SiteLogo'

/**
 * Full-screen branded loader for the public site.
 *
 * Rendered at the app root (not inside the layout) so it is present from the
 * very first React paint and covers the initial settings/mode fetch *and* the
 * lazy route chunk load with a single, consistent loader. `PublicLayout` fades
 * it out once the real page content has mounted (see `__fastaidPreloader`).
 */
export function Preloader() {
  return (
    <div className="preloader">
      <div className="preloader-icon">
        <SiteLoaderLogo />
      </div>
      <div className="preloader-text">
        <p>F</p>
        <p>A</p>
        <p>S</p>
        <p>T</p>
        <p>A</p>
        <p>I</p>
        <p>D</p>
      </div>
    </div>
  )
}
